import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import styles from "./NavMenuComponent.module.css";
import {
    UncontrolledDropdown,
    NavItem,
    Nav,
    NavLink,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
} from "reactstrap";
import { MdOutlineDashboard, MdOutlinePeople } from "react-icons/md";
import { FaRegClipboard, FaBuilding } from "react-icons/fa";
import { GiOfficeChair, GiHealing } from "react-icons/gi";
import { Context } from "../../context/authContext";

function NavMenuComponent() {
    const { userRole } = useContext(Context);
    const navigate = useNavigate();

    const handleNavigation = (path) => {
        navigate(path);
    };

    return (
        <div className={styles.mainDiv}>
            <div>
                <Nav>
                    <NavItem>
                        <NavLink 
                            onClick={() => handleNavigation('/home')} 
                            active 
                            className={styles.navDashboard}
                            style={{ cursor: 'pointer' }}
                        >
                            <MdOutlineDashboard className={styles.iconDashboard} />
                            Dashboard
                        </NavLink>
                    </NavItem>

                    <UncontrolledDropdown inNavbar nav>
                        <DropdownToggle caret nav className={styles.navVida}>
                            <MdOutlinePeople className={styles.iconVida} />
                            Vida
                        </DropdownToggle>
                        <DropdownMenu>
                            <DropdownItem 
                                onClick={() => handleNavigation('/vidas')} 
                                className={styles.itensDropdown}
                            >
                                Listar
                            </DropdownItem>
                            <DropdownItem 
                                onClick={() => handleNavigation('/cadastroVida')} 
                                className={styles.itensDropdown}
                            >
                                Cadastrar
                            </DropdownItem>
                        </DropdownMenu>
                    </UncontrolledDropdown>

                    {(userRole === "admin" || userRole === "parceiro" || userRole === "empresa") && (
                        <UncontrolledDropdown inNavbar nav>
                            <DropdownToggle caret nav className={styles.navAuxiliar}>
                                <GiOfficeChair className={styles.iconAuxiliar} />
                                Auxiliar
                            </DropdownToggle>
                            <DropdownMenu>
                                <DropdownItem 
                                    onClick={() => handleNavigation('/auxiliares')} 
                                    className={styles.itensDropdown}
                                >
                                    Listar
                                </DropdownItem>
                                <DropdownItem 
                                    onClick={() => handleNavigation('/cadastroAuxiliar')} 
                                    className={styles.itensDropdown}
                                >
                                    Cadastrar
                                </DropdownItem>
                            </DropdownMenu>
                        </UncontrolledDropdown>
                    )}

                    {userRole === "admin" && (
                        <UncontrolledDropdown inNavbar nav>
                            <DropdownToggle caret nav className={styles.navParceiro}>
                                <GiHealing className={styles.iconParceiro} />
                                Parceiro
                            </DropdownToggle>
                            <DropdownMenu>
                                <DropdownItem 
                                    onClick={() => handleNavigation('/parceiros')} 
                                    className={styles.itensDropdown}
                                >
                                    Listar
                                </DropdownItem>
                                <DropdownItem 
                                    onClick={() => handleNavigation('/cadastroParceiro')} 
                                    className={styles.itensDropdown}
                                >
                                    Cadastrar
                                </DropdownItem>
                            </DropdownMenu>
                        </UncontrolledDropdown>
                    )}

                    {userRole === "admin" && (
                        <UncontrolledDropdown>
                            <DropdownToggle caret nav className={styles.navEmpresa}>
                                <FaBuilding className={styles.iconEmpresa} />
                                Empresa
                            </DropdownToggle>
                            <DropdownMenu>
                                <DropdownItem 
                                    onClick={() => handleNavigation('/empresas')} 
                                    className={styles.itensDropdown}
                                >
                                    Listar
                                </DropdownItem>
                                <DropdownItem 
                                    onClick={() => handleNavigation('/cadastroEmpresa')} 
                                    className={styles.itensDropdown}
                                >
                                    Cadastrar
                                </DropdownItem>
                            </DropdownMenu>
                        </UncontrolledDropdown>
                    )}

                    <NavItem>
                        <NavLink 
                            onClick={() => handleNavigation('/questionarios')} 
                            className={styles.navListaQuestionario}
                            style={{ cursor: 'pointer' }}
                        >
                            <FaRegClipboard className={styles.iconQuestionario} />
                            Questionários
                        </NavLink>
                    </NavItem>
                </Nav>
            </div>
        </div>
    );
}

export default NavMenuComponent;